import { Link, NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";
import { Hourglass, House, Brain, FileText, ChartLineUp, Gear, SignOut } from "@phosphor-icons/react";

export default function AdminLayout() {
  const { admin, loading, logout } = useAdminAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--paper)]">
        <div className="label-mono text-[var(--muted)]">Chargement de la console…</div>
      </div>
    );
  }
  if (!admin) {
    return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  }

  const nav = [
    { to: "/admin", label: "Tableau de bord", icon: House, end: true, testid: "admin-nav-home" },
    { to: "/admin/llm", label: "Modèles IA", icon: Brain, testid: "admin-nav-llm" },
    { to: "/admin/cms", label: "Contenus CMS", icon: FileText, testid: "admin-nav-cms" },
    { to: "/admin/analytics", label: "Analytics", icon: ChartLineUp, testid: "admin-nav-analytics" },
    { to: "/admin/settings", label: "Compte & sécurité", icon: Gear, testid: "admin-nav-settings" },
  ];

  return (
    <div className="min-h-screen bg-[var(--paper)] text-[var(--ink)] grid grid-cols-[260px_1fr]" data-testid="admin-shell">
      {/* Sidebar */}
      <aside className="bg-[var(--ink)] text-[var(--paper)] border-r border-black flex flex-col">
        <Link to="/admin" className="block p-6 border-b border-white/10">
          <div className="flex items-center gap-3">
            <Hourglass weight="fill" size={22} className="text-[var(--signal)]" />
            <div>
              <div className="font-serif text-xl font-semibold leading-none">VITA-LEX</div>
              <div className="label-mono opacity-70 mt-1">CONSOLE ADMIN</div>
            </div>
          </div>
        </Link>
        <nav className="flex-1 py-4">
          {nav.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-6 py-3 text-sm border-l-2 ${
                    isActive
                      ? "border-[var(--signal)] bg-white/5 text-[var(--paper)]"
                      : "border-transparent text-[var(--paper)]/70 hover:text-[var(--paper)] hover:bg-white/5"
                  }`
                }
              >
                <Icon size={18} weight="bold" />
                <span>{it.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="p-6 border-t border-white/10 text-xs">
          <div className="label-mono opacity-60 mb-2">Connecté</div>
          <div className="font-mono text-[11px] break-all">{admin.email}</div>
          <button
            type="button"
            onClick={logout}
            className="mt-4 w-full bg-[var(--signal)] hover:bg-[var(--signal-hover)] text-[var(--paper)] py-2 label-mono flex items-center justify-center gap-2"
            data-testid="admin-logout-btn"
          >
            <SignOut size={14} weight="bold" /> Déconnexion
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="overflow-x-hidden">
        {admin.must_change_password && loc.pathname !== "/admin/settings" && (
          <div className="bg-[var(--signal)] text-[var(--paper)] px-6 py-3 label-mono flex items-center justify-between" data-testid="admin-must-change-banner">
            <span>⚠ Mot de passe initial à changer.</span>
            <Link to="/admin/settings" className="underline">Configurer →</Link>
          </div>
        )}
        <div className="p-8 max-w-[1400px] mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
